

































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
// eslint-disable-next-line no-unused-vars
import { ShoppingCart, User } from "@/types";
import SharedMixin from "@/mixins/shared";
import firebase from "firebase";

@Component({
  metaInfo: {
    title: "Ödeme"
  },
  name: "ShoppingCartPayment",
  mixins: [SharedMixin]
})
export default class ShoppingCartPayment extends Vue {
  get cart(): ShoppingCart {
    return this.$store.getters["ecommerce/shoppingCart"];
  }

  get cartItemCount(): Number {
    return this.$store.getters["ecommerce/cartItemCount"];
  }

  get user(): User {
    return this.$store.getters["auth/user"];
  }

  get userSignedIn(): boolean {
    return this.$store.getters["auth/userSignedIn"];
  }

  paymentForm = {
    billType: "bireysel",
    name: `${this.user.firstName} ${this.user.lastName}`,
    corpName: "",
    tckn: "",
    taxNumber: "",
    email: this.user.email,
    phone: this.user.phone,
    address: "",
    paymentType: "creditcard" as "creditcard" | "transfer",
    ccNumber: "",
    ccHolder: "",
    ccDate: "",
    ccCvc: "",
    installment: 1,
    confirm: false
  };

  get nameRules() {
    return [(v: string) => !!v || "Lütfen adınızı yazınız"];
  }

  get corpNameRules() {
    return [(v: string) => !!v || "Lütfen kurum adınızı yazınız"];
  }

  get tcknRules() {
    return [
      (v: string) => !!v || "Lütfen TC kimlik numaranızı yazınız",
      (v: string) =>
        /^[1-9]{1}[0-9]{9}[02468]{1}$/.test(v) || "Geçersiz TC kimlik numarası"
    ];
  }

  get taxNumberRules() {
    return [
      (v: string) => !!v || "Lütfen vergi numaranızı yazınız",
      (v: string) => /^[0-9]{10}$/.test(v) || "Geçersiz vergi numarası"
    ];
  }

  get emailRules() {
    return [
      (v: string) => !!v || "Lütfen e-postanızı yazınız",
      (v: string) => /.+@.+\..+/.test(v) || "Geçersiz e-posta adresi"
    ];
  }

  get phoneRules() {
    return [
      (v: string) => !!v || "Lütfen telefon numaranızı yazınız",
      (v: string) =>
        // Tr telefon 0532 111 11 11 ya da 05321111111
        /^(05)([0-9]{2})\s?([0-9]{3})\s?([0-9]{2})\s?([0-9]{2})$/.test(v) ||
        // Genel +90|00 ile başlayan 8-13 uzunluğunda boşluk ve - içerebilen
        /^((\+|00)[0-9]{1,3})\s?([0-9\s-]{8,13})$/.test(v) ||
        "Geçersiz numara (Örn: 0532 111 11 11 veya +90 532 111 11 11)"
    ];
  }

  get cityRules() {
    return [(v: string) => !!v || "Lütfen şehir adını yazınız"];
  }

  get addressRules() {
    return [(v: string) => !!v || "Lütfen açık adresinizi yazınız"];
  }

  get ccNumberRules() {
    return [
      (v: string) => !!v || "Lütfen kart numaranızı yazınız",
      (v: string) =>
        /^([0-9]{4})\s?([0-9]{4})\s?([0-9]{4})\s?([0-9]{4})$/.test(v) ||
        "Geçersiz kart numarası"
    ];
  }

  get ccHolderRules() {
    return [(v: string) => !!v || "Lütfen kart sahibini yazınız"];
  }

  get ccDateRules() {
    return [
      (v: string) => !!v || "Lütfen kartınızın son kullanma tarihini yazınız",
      (v: string) => /^([0-9]{2})\/([0-9]{2})$/.test(v) || "Geçersiz tarih"
    ];
  }

  get ccCvcRules() {
    return [
      (v: string) => !!v || "Lütfen CVC kodunu yazınız",
      (v: string) => /^([0-9]{3})$/.test(v) || "Geçersiz CVC"
    ];
  }

  get confirmRules() {
    return [
      this.paymentForm.confirm ||
        "Lütfen mesafeli satış sözleşmesini onaylayınız."
    ];
  }

  validate() {
    const form: any = this.$refs.form;
    return form.validate();
  }

  installmentInfos = {
    binNumber: "",
    price: this.cart.amount,
    cardType: "",
    cardAssociation: "",
    cardFamilyName: "",
    force3ds: 0,
    bankCode: 0,
    bankName: "",
    forceCvc: 0,
    commercial: 0,
    installmentPrices: [
      {
        installmentPrice: this.cart.amount,
        totalPrice: this.cart.amount,
        installmentNumber: 1
      }
    ]
  };

  get defaultInstallmentInfos() {
    return {
      binNumber: "",
      price: this.cart.amount,
      cardType: "",
      cardAssociation: "",
      cardFamilyName: "",
      force3ds: 0,
      bankCode: 0,
      bankName: "",
      forceCvc: 0,
      commercial: 0,
      installmentPrices: [
        {
          installmentPrice: this.cart.amount,
          totalPrice: this.cart.amount,
          installmentNumber: 1
        }
      ]
    };
  }

  async getInstallmentInfos() {
    const getInstallmentInfosFunc = firebase
      .functions()
      .httpsCallable("ecommerce-getInstallmentInfos");

    const res = await getInstallmentInfosFunc({
      binNumber: this.paymentForm.ccNumber.substring(0, 6),
      price: this.cart.amount
    });

    // console.log(res);

    if (res.data.status === "success") {
      this.installmentInfos = res.data.installmentDetails[0];
      this.$notify("Taksit seçenekleri güncellendi.");
    } else {
      // Varsayılan taksit seçeneklerini yükle
      this.installmentInfos = this.defaultInstallmentInfos;

      this.$notify({
        type: "error",
        text: "HATA: Taksit seçenekleri alınamadı."
      });
    }
  }

  async onCcNumberInput() {
    // Kredi kartı numarasının ilk 6 hanesi binNumber
    if (this.paymentForm.ccNumber.length == 6) {
      await this.getInstallmentInfos();
    }
  }

  async onCcNumberChange() {
    // Kredi kartı numarasının ilk 6 hanesi binNumber
    if (this.paymentForm.ccNumber.length >= 6) {
      await this.getInstallmentInfos();
    }
  }

  createCcMask() {
    const normalizedCcNumber = this.paymentForm.ccNumber.replace(/ /g, "");
    const last4Digit = normalizedCcNumber.substring(
      normalizedCcNumber.length - 4,
      normalizedCcNumber.length
    );

    return "************" + last4Digit;
  }

  orderId = "";

  async saveOrder() {
    // Sipariş oluştur
    const newOrder = await firebase
      .firestore()
      .collection("/orders")
      .add({
        uid: this.user.id,
        billType: this.paymentForm.billType,
        name: this.paymentForm.name,
        tckn: this.paymentForm.tckn,
        email: this.paymentForm.email,
        phone: this.paymentForm.phone,
        corpName: this.paymentForm.corpName,
        taxNumber: this.paymentForm.taxNumber,
        address: this.paymentForm.address,
        paymentType: this.paymentForm.paymentType,
        ccNumber:
          this.paymentForm.paymentType == "creditcard"
            ? this.createCcMask()
            : "",
        ccHolder:
          this.paymentForm.paymentType == "creditcard"
            ? this.paymentForm.ccHolder
            : "",
        dateCreated: firebase.firestore.FieldValue.serverTimestamp(),
        cartId: this.cart.id,
        items: this.cart.items,
        amount: this.cart.amount,
        installment: this.paymentForm.installment,
        installmentInfos: this.installmentInfos,
        status: "", // success | error
        statusMessage:
          this.paymentForm.paymentType == "transfer"
            ? "Para transferi bekleniyor..."
            : "",
        paymentDetails: null
      });

    return newOrder.id;
  }

  threeDSHtmlContent = "";

  callbackUrl =
    "https://us-central1-ute-akademi.cloudfunctions.net/ecommerce-iyzipay3dCallback";

  paymentDialog = false;

  paymentDialogTitle = "Ödeme Onayı";

  paymentFrameSrc = "#";

  async takePayment() {
    this.$notify({
      text: "Ödeme alınıyor, lütfen bekleyin...",
      duration: -1
    });

    // Siparişi kaydet
    this.orderId = await this.saveOrder();

    // Ödemeyi al
    const paymentFunc = firebase
      .functions()
      .httpsCallable("ecommerce-payWithIyzico");

    const payRes = await paymentFunc({
      conversationId: this.orderId,
      installment: this.paymentForm.installment,
      installmentInfos: this.installmentInfos,
      cart: {
        id: this.cart.id,
        items: this.cart.items,
        amount: this.cart.amount
      },
      paymentCard: {
        ccHolder: this.paymentForm.ccHolder,
        ccNumber: this.paymentForm.ccNumber,
        ccDate: this.paymentForm.ccDate,
        ccCvc: this.paymentForm.ccCvc
      },
      user: {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email
      },
      billingAddress: {
        name:
          this.paymentForm.billType == "bireysel"
            ? this.paymentForm.name
            : this.paymentForm.corpName,
        address: this.paymentForm.address
      },
      callbackUrl: this.callbackUrl
    });

    // console.log(payRes);

    if (payRes.data.status == "success") {
      // Eğer kullanılan kredi kartı 3D ödemeyi zorunlu tutmuşsa
      if (this.installmentInfos.force3ds === 1) {
        // 3D ödemeye yönlendir
        this.threeDSHtmlContent = payRes.data.threeDSHtmlContent;
        this.paymentFrameSrc = `data:text/html;base64,${this.threeDSHtmlContent}`;
        this.paymentDialog = true;

        // Varolan mesajları temizle
        this.$notify({
          clean: true
        });
      } else {
        // Ödeme onayına yönlendir
        this.paymentFrameSrc = this.$router.resolve({
          name: "shopping-cart-result",
          params: {
            orderId: this.orderId
          }
        }).href;
        this.paymentDialog = true;

        // Varolan mesajları temizle
        this.$notify({
          clean: true
        });
      }
    } else {
      this.$notify({
        clean: true
      });

      this.$notify({
        type: "error",
        text: `Ödeme alınamadı. HATA ${payRes.data.errorCode}: ${payRes.data.errorMessage}`,
        duration: -1
      });
    }
  }

  async takeTransfer() {}

  submitDisabled = false;

  async submit() {
    // Formu kontrol et
    if (!this.validate()) return;

    try {
      this.submitDisabled = true;

      if (this.paymentForm.paymentType == "transfer") {
        await this.takeTransfer();
      } else {
        await this.takePayment();
      }
    } finally {
      this.submitDisabled = false;
    }
  }

  mounted() {
    this.$emit("setStep", 2);

    if (this.cartItemCount === 0) {
      this.$router.push({ name: "shopping-cart-index" });
    }
  }
}
